import React, { useContext } from 'react';

export interface Step {
  displayName: string;
  isComplete?: boolean;
  key: string;
  route: string;
}

export interface Progress {
  steps: Step[];
  percentage: number;
}

export interface ProgressOptions {
  label: string;
  disableSkip: boolean;
  getRoute: (route: string) => string;
}

export interface ProgressState {
  currentStep: number;
  options: ProgressOptions;
  progress: Progress;
  setOptions: (input: ProgressOptions) => void;
  setProgress: (input: Progress) => void;
}

// Only exported for use in tests/mocks; do NOT reference directly in prod code
export const ProgressContext = React.createContext<ProgressState>({} as ProgressState);

export default function useProgress(): ProgressState {
  return useContext(ProgressContext);
}
